module.exports = __webpack_public_path__ + "static/media/D5.f0c75243.png";